import { FetchSolutions } from '@/connection/integrations/integrations';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const fetchSolutionsReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: number }, { rejectWithValue }) => {
      try {
        const instances = await FetchSolutions(channel);
        return instances;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.solutions = action.payload.solutions;
        state.solutionsMapped = action.payload.mappedSolutions;
      },
    }
  );
};

export default fetchSolutionsReducer;
